export default "__VITE_ASSET__oJtMcQ_b__"